if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;

        /* CDS Bundle Picker — validate required pickers */
        if (typeof window._cdsBundlePickerValidate === 'function') {
          const bundleErr = window._cdsBundlePickerValidate();
          if (bundleErr) {
            this.handleErrorMessage(bundleErr);
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        /* CDS Bundle Picker — check for bundle items */
        const bundleItems = typeof window._cdsBundlePickerGetItems === 'function' ? window._cdsBundlePickerGetItems() : [];

        if (bundleItems.length > 0) {
          /* Multi-item add: main product + bundle items */
          const mainVariantId = parseInt(this.variantIdInput.value);
          const qtyInput = this.form.querySelector('[name="quantity"]');
          const mainQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

          /* Generate unique group ID to link parent ↔ children in cart */
          const bundleGroupId = Date.now().toString(36) + Math.random().toString(36).substr(2, 5);

          /* Collect existing form properties (Globo, custom fields, etc.) */
          const formData = new FormData(this.form);
          const mainProperties = {};
          for (const [key, value] of formData.entries()) {
            if (key.startsWith('properties[') && value) {
              const propName = key.replace('properties[', '').replace(']', '');
              mainProperties[propName] = value;
            }
          }
          /* Also capture Globo Product Options hidden inputs (may be outside the <form>) */
          document.querySelectorAll('.gpo-hidden-inputs input[name^="properties["], .gpo-app input[name^="properties["], .gpo-app select[name^="properties["], .gpo-app textarea[name^="properties["]').forEach(function(input) {
            if (!input.value) return;
            var propName = input.name.replace('properties[', '').replace(']', '');
            if (!mainProperties[propName]) {
              mainProperties[propName] = input.value;
            }
          });
          mainProperties['_bundle_group'] = bundleGroupId;

          /* Remove parent properties that are duplicated on children (avoid double notes) */
          bundleItems.forEach(bi => {
            if (bi.properties) {
              Object.keys(bi.properties).forEach(k => {
                if (k.startsWith('_')) return;
                if (mainProperties[k] && mainProperties[k] === bi.properties[k]) {
                  delete mainProperties[k];
                }
              });
            }
          });

          /* Build parent label with dedup number for children */
          const productTitleEl = document.querySelector('.product__title h1') || document.querySelector('h1.product-title');
          const baseTitle = productTitleEl ? productTitleEl.textContent.trim().split('\n')[0].trim() : 'Produit';
          const sectionsToFetch = this.cart ? this.cart.getSectionsToRender().map(s => s.id) : [];

          /* Fetch current cart to count same-name parents for dedup numbering */
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(r => r.json())
            .then(cartData => {
              let sameCount = 0;
              (cartData.items || []).forEach(ci => {
                if (ci.properties && ci.properties['_bundle_group'] && ci.product_title === baseTitle) {
                  sameCount++;
                }
              });
              const parentLabel = sameCount > 0 ? baseTitle + ' ' + (sameCount + 1) : baseTitle;

              const items = [{ id: mainVariantId, quantity: mainQty, properties: mainProperties }];
              bundleItems.forEach(bi => {
                bi.properties = bi.properties || {};
                bi.properties['_bundle_parent'] = bundleGroupId;
                bi.properties['Produit parent'] = parentLabel;
                items.push(bi);
              });

          fetch(`${theme.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items, sections: sectionsToFetch, sections_url: window.location.pathname })
          })
            .then(r => r.json())
            .then(response => {
              if (response.status) {
                this.handleErrorMessage(response.description || response.message);
                this.error = true;
                return;
              }

              if (!this.cart) {
                window.location = theme.routes.cart_url;
                return;
              }

              if (!this.error) {
                /* Fetch full cart data for pub/sub (cart/add.js response lacks item_count) */
                fetch('/cart.js').then(r => r.json()).then(cartData => {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: String(mainVariantId),
                    cartData: cartData,
                  });
                }).catch(() => {});
              }
              this.error = false;

              /* Reset bundle pickers after successful add */
              if (typeof window._cdsBundlePickerReset === 'function') {
                window._cdsBundlePickerReset();
              }
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response); });
                }, { once: true });
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch(e => { console.error(e); })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            });
            }).catch(e => { console.error(e); this.submitButton.classList.remove('loading'); this.submitButton.removeAttribute('aria-disabled'); });
        } else {
          /* Standard single item add (original behavior) */
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = theme.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            });
        }
      }

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error("Expected a form element.");
        }

        const formId = this.form.getAttribute('id');
        const requiredFields = document.querySelectorAll('[required]');
        let allFilled = true;
        for (const field of requiredFields) {
          const belongsToForm = (field.getAttribute('form') === formId || field.closest('form')?.id === formId);
          if (!belongsToForm) continue;
          
          let isValid = true;
          switch (field.type) {
            case 'checkbox':
            case 'radio':
              const group = document.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
              const isChecked = Array.from(group).some(input => input.checked);
              isValid = isChecked;
              break;
            case 'select-one':
              isValid = field.value !== '';
              break;
            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid = field.value.trim() !== '';
              break;
          }
          if (!isValid) {
            allFilled = false;
            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }
    
        if (!allFilled) {
          event.preventDefault();
          this.handleErrorMessage(theme.accessibilityStrings.fillInAllLineItemPropertyRequiredFields);
          return false;
        }
        return true;
      }
      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
